var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostLaunchSupportMaintenance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6262 142.063C68.7997 142.063 63.9733 142.031 59.1469 142.088C57.9975 142.101 57.4767 141.974 57.4831 140.588C57.4958 137.874 56.2638 135.643 54.3395 133.723C46.5538 125.981 38.8887 118.125 31.0267 110.466C25.7811 105.349 24.1681 99.3549 25.3874 92.2677C26.9877 82.9684 28.4229 73.6438 29.8645 64.3191C30.4869 60.2765 33.8781 58.2616 37.3582 60.0223C38.9839 60.8423 39.9555 62.158 39.8984 64.0267C39.7142 70.0716 39.4729 76.1164 39.2824 82.1612C39.2633 82.8095 38.9014 83.1528 38.5013 83.5532C34.2019 87.8564 34.113 94.2127 38.3743 98.5667C42.8514 103.143 47.4111 107.643 51.9454 112.163C53.0821 113.294 54.1871 113.44 54.9619 112.544C55.9335 111.425 55.3937 110.504 54.5237 109.633C49.9577 105.069 45.3535 100.55 40.8573 95.9161C37.2121 92.1532 38.7426 86.1275 43.677 84.6274C46.3887 83.8075 48.7638 84.5066 50.7769 86.5343C55.7557 91.543 60.779 96.5136 65.7388 101.541C66.6279 102.444 67.5804 103.073 68.8252 103.315C72.7879 104.09 76.0965 106.016 78.859 108.966C80.4911 110.707 82.1867 112.398 83.9204 114.038C87.7434 117.648 89.7185 122.034 89.7439 127.31C89.7629 131.835 89.8137 136.361 89.909 140.88C89.928 141.821 89.655 142.088 88.7151 142.075C83.6854 142.031 78.6558 142.056 73.6262 142.056V142.063Z",
    fill: "url(#paint0_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.221 142.062C121.243 142.062 116.264 142.037 111.285 142.081C110.294 142.088 109.989 141.815 110.009 140.81C110.11 135.776 110.009 130.742 110.294 125.714C110.504 121.977 111.78 118.646 114.314 115.913C117.007 113.008 119.839 110.23 122.678 107.465C125.002 105.202 127.904 104.014 131.022 103.34C132.305 103.06 133.309 102.45 134.242 101.503C139.196 96.4689 144.194 91.4792 149.21 86.5023C151.878 83.8581 155.688 83.5848 158.463 85.765C161.721 88.3265 161.969 92.992 158.92 96.0939C154.615 100.486 150.239 104.808 145.895 109.156C144.295 110.758 144.06 111.673 145.013 112.607C145.915 113.497 146.931 113.23 148.474 111.686C152.678 107.478 156.882 103.276 161.08 99.0686C165.849 94.2824 165.919 88.263 161.251 83.4004C160.876 83.0127 160.661 82.6377 160.641 82.0847C160.445 76.2941 160.197 70.5036 160.032 64.713C159.943 61.6683 161.658 59.7233 164.528 59.4373C167.316 59.164 169.507 60.8674 169.977 63.7977C171.622 74.0694 173.362 84.3221 174.81 94.6192C175.629 100.435 173.781 105.539 169.57 109.734C161.658 117.629 153.789 125.574 145.845 133.443C143.673 135.592 142.333 138.033 142.415 141.115C142.441 142.209 141.812 142.056 141.158 142.056C136.179 142.056 131.2 142.056 126.221 142.056V142.062Z",
    fill: "url(#paint1_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.521 88.9751C95.6118 88.9751 88.7024 88.9496 81.793 89.0005C80.7261 89.0068 80.4022 88.7272 80.434 87.6466C80.5102 85.0024 80.5165 82.3582 80.4467 79.714C80.3133 74.915 82.428 71.33 86.232 68.6096C87.4323 67.7515 88.7723 67.1349 90.0805 66.4675C91.6109 65.6857 92.7985 65.7747 94.329 66.8362C99.5428 70.4656 106.56 70.1986 111.704 66.3722C112.498 65.781 113.127 65.6666 114.041 66.0162C116.626 67.0141 119.02 68.2981 121.033 70.2304C123.586 72.6839 124.837 75.6968 124.875 79.2182C124.907 81.9641 124.824 84.71 124.907 87.4559C124.939 88.6255 124.647 89.0132 123.402 89.0005C116.442 88.9369 109.481 88.9687 102.521 88.9687V88.9751Z",
    fill: "url(#paint2_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6388 145.718C80.5927 145.718 87.5465 145.743 94.494 145.692C95.6435 145.686 95.9546 146.004 95.9356 147.141C95.8657 150.898 95.8721 154.661 95.9356 158.417C95.9546 159.562 95.7006 160.007 94.4305 160C80.5228 159.956 66.6215 159.956 52.7137 160C51.469 160 51.1833 159.6 51.2087 158.437C51.2722 154.731 51.2849 151.019 51.2087 147.313C51.1833 146.074 51.4881 145.679 52.7836 145.692C59.7375 145.756 66.6913 145.724 73.6388 145.724V145.718Z",
    fill: "url(#paint3_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.304 145.717C133.258 145.717 140.212 145.743 147.159 145.692C148.309 145.686 148.734 145.934 148.709 147.179C148.62 150.987 148.645 154.801 148.702 158.608C148.721 159.682 148.372 159.987 147.318 159.987C133.359 159.955 119.407 159.955 105.449 159.987C104.331 159.987 103.95 159.689 103.975 158.532C104.045 154.724 104.052 150.911 103.975 147.103C103.95 145.914 104.35 145.679 105.449 145.686C112.403 145.737 119.356 145.711 126.304 145.711V145.717Z",
    fill: "url(#paint4_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.428 77.9022C136.827 77.9022 133.226 77.9022 129.625 77.9022C129.047 77.9022 128.425 78.0612 128.304 77.1014C127.612 71.4697 124.405 67.5288 119.655 64.7638C118.518 64.1028 118.652 63.7214 119.433 62.9459C120.976 61.4204 122.792 60.3526 124.761 59.5008C125.37 59.2402 125.821 59.3102 126.399 59.7424C131.626 63.696 137.563 63.7023 142.803 59.7742C143.412 59.3165 143.908 59.2402 144.581 59.539C148.817 61.3823 153.027 64.5096 152.659 71.2917C152.563 73.0143 152.576 74.7495 152.671 76.4657C152.735 77.6035 152.386 77.9595 151.23 77.9404C147.629 77.8705 144.028 77.915 140.428 77.915V77.9022Z",
    fill: "url(#paint5_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5956 77.9026C61.1473 77.9026 57.6926 77.8645 54.2442 77.928C53.1075 77.9471 52.6058 77.7183 52.6883 76.4407C52.8027 74.6228 52.809 72.7794 52.701 70.9615C52.3835 65.6986 55.0825 62.3869 59.4898 60.0796C60.8361 59.3741 61.8522 59.2342 63.2684 60.283C67.7773 63.6328 73.9309 63.4993 78.4208 60.0669C79.4496 59.2787 80.218 59.2851 81.2658 59.8063C82.9106 60.6263 84.4474 61.5797 85.7811 62.8637C86.613 63.6582 86.759 64.1222 85.5651 64.815C81.3674 67.2558 78.37 70.6946 77.2396 75.5508C76.6871 77.9153 76.6807 77.909 74.1913 77.909C70.997 77.909 67.7963 77.909 64.602 77.909L64.5956 77.9026Z",
    fill: "url(#paint6_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.352 54.0729C114.314 60.6325 109.031 65.8383 102.477 65.7748C96.0881 65.7175 90.7854 60.2766 90.8807 53.8949C90.9759 47.3543 96.2469 42.2693 102.89 42.3138C109.259 42.3583 114.397 47.6276 114.359 54.0729H114.352Z",
    fill: "url(#paint7_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.136 49.6616C144.098 54.8673 139.78 59.1006 134.547 59.0688C129.346 59.0371 125.059 54.7021 125.097 49.5027C125.136 44.2778 129.441 39.9873 134.63 40C139.92 40.0127 144.174 44.3414 144.136 49.6616Z",
    fill: "url(#paint8_linear_35_691)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1482 49.5405C80.1482 54.8035 75.9378 59.0559 70.7049 59.0686C65.3959 59.0813 61.1473 54.7972 61.1854 49.4643C61.2235 44.2076 65.4975 39.9616 70.7113 39.9998C75.9695 40.0379 80.1482 44.2648 80.1482 49.5405Z",
    fill: "url(#paint9_linear_35_691)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_691",
    x1: 57.4556,
    y1: 59.3823,
    x2: 57.4556,
    y2: 142.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_691",
    x1: 142.504,
    y1: 59.4087,
    x2: 142.504,
    y2: 142.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_691",
    x1: 102.671,
    y1: 65.8193,
    x2: 102.671,
    y2: 89.0008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_691",
    x1: 73.5719,
    y1: 145.692,
    x2: 73.5719,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_691",
    x1: 126.342,
    y1: 145.686,
    x2: 126.342,
    y2: 159.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_691",
    x1: 135.753,
    y1: 59.3486,
    x2: 135.753,
    y2: 77.9411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35_691",
    x1: 69.5544,
    y1: 59.4409,
    x2: 69.5544,
    y2: 77.9291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35_691",
    x1: 102.619,
    y1: 42.3135,
    x2: 102.619,
    y2: 65.7753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_35_691",
    x1: 134.617,
    y1: 40,
    x2: 134.617,
    y2: 59.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_35_691",
    x1: 70.6667,
    y1: 39.9995,
    x2: 70.6667,
    y2: 59.0686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 120,
    fill: "white",
    transform: "translate(25 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostLaunchSupportMaintenance);
export default __webpack_public_path__ + "static/media/Post-Launch_Support_&_Maintenance.5ac85de4db1e496b3ce559ccecb6a0e2.svg";
export { ForwardRef as ReactComponent };